module.exports = "/lucky-balls/img/drawnballs/orange.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/orange.png
// module id = 1012
// module chunks = 0